import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const PressReleaseArticleStyles = styled.div`
  padding-top: 55px;
  .articleContainer {
    max-width: 808px;
    margin: 0 auto;
    a {
      display: inline-block;
    }
    img {
      width: 100%;
      padding-bottom: 25px;
    }
  }
  .pr-categories {
    color: ${Colors.accent.grey2.standard};
    font-size: 12px;
    margin-bottom: 10px;
    font-weight: 600;
    padding-left: 2px;
  }
  .pr-media {
    position: relative;
    max-width: 808px;
    margin: 0 auto;

    img {
      width: 100%;
      height: auto;
    }
  }
  .subheadline {
    font-size: 18px;
    color: ${Colors.primary.black.standard};
    margin-top: 6px;
    line-height: 29px;
  }

  .publication-date {
    margin-top: 25px;
    margin-bottom: 22px;
    color: ${Colors.primary.white.tint};
  }
  .video-container,
  .quiz-container {
    margin-bottom: 50px;
    h4,
    p {
      margin-bottom: 16px;
    }
    .disclaimer {
      padding-top: 30px;
    }
  }
  .quiz-container {
    p {
      margin-bottom: 16px;
    }
    iframe {
      border: none;
    }
  }
  .video-wrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .pr-categories {
      margin-top: 25px;
    }

    .articleContainer {
      .h3 {
        line-height: 38px;
      }
    }
  }
`;

export default PressReleaseArticleStyles;
